module.exports = __webpack_public_path__ + "img/wallet-icon.ded8a2e9.svg";